import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../assets/css/Navbar.module.css';
import CrmLogo from '../assets/img/crmLogo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  return (
    <header className="fixed w-full bg-white bg-opacity-80 backdrop-blur-md z-50">
      <div className="container mx-auto px-4 py-2 flex justify-between items-center">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src={CrmLogo} alt="CRM Landing" className="h-10" />
          </Link>
        </div>

        {/* Navigation for desktop */}
        <nav className="hidden lg:flex space-x-4">
          <Link to="/solutions" className="text-black hover:text-gray-700">
            Solution
          </Link>
          <div className="relative group">
            <button className="text-teal-500 hover:text-teal-400">Industries</button>
            <ul className="absolute hidden group-hover:flex flex-col bg-white border shadow-lg mt-2">
              <li>
                <Link
                  to="/industries"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Automobile Industry
                </Link>
              </li>
            </ul>
          </div>
          <div className="relative group">
            <button className="text-black hover:text-gray-700">Products</button>
            <ul className="absolute hidden group-hover:flex flex-col bg-white border shadow-lg mt-2 w-64">
              <li>
                <Link
                  to="/products/dms-primary-sales"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  DMS for Primary Sales
                </Link>
              </li>
              <li>
                <Link
                  to="/products/sales-force-automation"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Sales Force Automation
                </Link>
              </li>
            </ul>
          </div>
          <Link to="/case-studies" className="text-black hover:text-gray-700">
            Case Studies
          </Link>
          <Link to="/about-us" className="text-black hover:text-gray-700">
            Why CRML
          </Link>
        </nav>

        {/* Hamburger Icon for Mobile */}
        <div className="lg:hidden">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-black focus:outline-none"
          >
            {/* Hamburger icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          </button>
        </div>

        {/* Contact Button */}
        <button className={`${styles.gradientButton} hidden lg:block px-4 py-2 rounded-lg`}>
          <Link to="/contact-us">Contact Sales</Link>
        </button>
      </div>

      {/* Mobile Navigation Menu */}
      <div
        className={`fixed top-0 left-0 h-full w-full bg-white transform ${
          isMenuOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300 ease-in-out z-40`}
      >
        <div className="flex justify-between items-center p-4 bg-white">
          <img src={CrmLogo} alt="CRM Landing" className="h-10" />
          <button onClick={() => setIsMenuOpen(false)} className="text-gray-700 focus:outline-none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <nav className="h-screen p-4 bg-white">
          <ul className="space-y-4 px-4 " >
            <li className='font-bold border-b border-[#DADADA] py-2'>
              <button
                onClick={() => toggleDropdown('solution')}
                className="flex items-center justify-between w-full text-black hover:text-gray-700"
              >
                Solution
                <span className="text-gray-400">{openDropdown === 'solution' ? '-' : '+'}</span>
              </button>
            </li>
            <li className='font-bold border-b border-[#DADADA] py-2'>
              <button
                onClick={() => toggleDropdown('industries')}
                className="flex items-center justify-between w-full text-black hover:text-gray-700"
              >
                Industries
                <span className="text-gray-400">{openDropdown === 'industries' ? '-' : '+'}</span>
              </button>
              {openDropdown === 'industries' && (
                <ul className="mt-2 pl-4 border-l border-gray-300">
                  <li>
                    <Link
                      to="/automobile-industry"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Automobile Industry
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className='font-bold border-b border-[#DADADA] py-2'>
              <button
                onClick={() => toggleDropdown('products')}
                className="flex items-center justify-between w-full text-black hover:text-gray-700"
              >
                Products
                <span className="text-gray-400">{openDropdown === 'products' ? '-' : '+'}</span>
              </button>
              {openDropdown === 'products' && (
                <ul className="mt-2 pl-4 border-l border-gray-300">
                  <li>
                    <Link
                      to="/products/dms-primary-sales"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      DMS for Primary Sales
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products/sales-force-automation"
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Sales Force Automation
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li className='font-bold border-b border-[#DADADA] py-2'>
              <Link to="/case-studies" className="flex items-center justify-between text-black hover:text-gray-700">
                Case Studies
              </Link>
            </li>
            <li className='font-bold border-b border-[#DADADA] py-2'>
              <Link to="/about-us" className="flex items-center justify-between text-black hover:text-gray-700">
                Why CRML
              </Link>
            </li>
            <li className='font-bold hidden lg:block border-b border-[#CCCCCC] py-2'>
              <Link to="/contact-us" className="text-black hover:text-gray-700">
                Contact Sales
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
